const feedItems = {
  create(props, limit = 17) {
    let markup = '<div class="cardPage js-card-page">';
    for (let i = 1; i < limit; i += 1) {
      const index = i - 1;
      markup += `
        <div class="grid__column -desktop-3 card -home">
          <a class="card__article" href="${props[index].link}" target="_blank">
            <figure class="card__thumbnail" style="background-image: url(${props[index].full_picture});">
            </figure>
            <div class="card__body">
              <header>
                <figure class="card__avatar" style="background-image: url(${props[index].from.picture});"></figure>
                <h4 class="card__title">${props[index].from.name}</h4>
                <time class="card__time">${props[index].date}</time>
              </header>
              <p class="card__paragraph">
                "${props[index].message}"
              </p>
            </div>
          </a>
        </div>
      `;
      if (i % 4 === 0 && i < limit - 1) markup += '</div><div class="cardPage js-card-page">';
    }
    return `${markup}</div>`;
  },

  createMobile(props, limit = 7) {
    let markup = '';
    for (let i = 1; i < limit; i += 1) {
      const index = i - 1;
      markup += `
        <a href="${props[index].link}" target="_blank" class="${i > (limit - 3) ? '-tablet' : ''}">
          <figure style="background-image: url(${props[index].full_picture})"></figure>
        </a>
      `;
    }

    return markup;
  },
};

export default feedItems;



// WEBPACK FOOTER //
// ./components/markup/feedItems.js